import { Layout, SlideoutDecorator, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutARCallHistory } from "./autogen/AutogenLayoutARCallHistory";
import { ModelRow, StringUtil } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";

interface ARCallHistorySlideoutProps {
    showSearchPanel: boolean;
    customerId?: string;
    customerName?: string;
    orderId?: string;
}

export class ARCallHistory extends AutogenLayoutARCallHistory {
    public static showSlideout(props: ARCallHistorySlideoutProps) {
        const layout = Layout.getLayout("lme/ar/ARCallHistory") as ARCallHistory;
        const title = layout.buildSlideoutTitle(props);

        new SlideoutDecorator({
            layout,
            width: "75%",
            fillVerticalSpace: true,
            title,
            displayOverlay: true,
            overlayProps: { greyedBackground: true },
            layoutLoadListeners: () => {
                layout.searchpanelCallHistory.visible = props.showSearchPanel;
                const searchParams: any = {};
                if (props.customerId != null) {
                    searchParams.customer_id = props.customerId;
                }
                if (props.orderId != null) {
                    searchParams.order_id = props.orderId;
                }
                if (Object.keys(searchParams).length > 0) {
                    layout.mainDataSource.search(searchParams);
                }
                layout.populateSearchPanelFields(props);
            }
        });
    }

    private buildSlideoutTitle(props: ARCallHistorySlideoutProps): string {
        let title = "Call History";

        if (!props.showSearchPanel) {
            if (!StringUtil.isEmptyString(props.customerName)) {
                title += ` - ${props.customerName}`;
            } else if (!StringUtil.isEmptyString(props.customerId)) {
                title += ` - ${props.customerId}`;
            }

            if (!StringUtil.isEmptyString(props.orderId)) {
                title += ` - Order ${props.orderId}`;
            }
        }

        return title;
    }

    private populateSearchPanelFields(props: ARCallHistorySlideoutProps) {
        if (props?.showSearchPanel) {
            const searchRow = this.mainDataSource.searchRow;
            if (props.customerId != null) {
                searchRow.setValueAndLookupModelData("customer_id", props.customerId, { id: props.customerId, name: props.customerName ?? null });
            }
            if (props.orderId != null) {
                searchRow.setValueAndLookupModelData("order_id", props.orderId, { order_id: props.orderId });
            }
            this.searchpanelCallHistory.displayComponentData(this.mainDataSource.searchRow, null, 0);
        }
    }

    tableCallHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;

        if (modelRow != null) {
            const multipleOrders = modelRow.getBoolean("multiple_orders", false);
            const labelOrderIds = tableRow.findComponentById("labelOrderIds");
            const imageMultipleOrders = tableRow.findComponentById("imageMultipleOrders");
            if (labelOrderIds != null) {
                labelOrderIds.visible = !multipleOrders;
                imageMultipleOrders.visible = multipleOrders;
                imageMultipleOrders.tooltip = modelRow.getString("order_ids", "");
            }

            const labelCustomerName = tableRow.findComponentById("labelCustomerName");
            if (labelCustomerName != null) {
                const customerId = modelRow.getString("customer_id", "");
                CommonTooltips.setTooltipContentLayout(labelCustomerName, customerId, "lme/ar/CustomerQuickInfo");
            }
        }
    }
}
